import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { solarServicePages } from "@/data/solarServiceContent";

export const Route = createFileRoute("/services/solar-panel-replacement")({
  head: () => ({
    meta: [
      { title: "Solar Panel Replacement in Southern California – McKay Roofing & Solar" },
      { name: "description", content: "Upgrade aging solar arrays to modern, high-efficiency panels across Southern California. New inverters, racking and monitoring included." },
      { property: "og:title", content: "Solar Panel Replacement in Southern California – McKay Roofing & Solar" },
      { property: "og:description", content: "Replace older solar systems with modern high-output panels in Southern California." },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/solar-panel-replacement" }],
  }),
  component: () => <RoofingServicePage {...solarServicePages["solar-panel-replacement"]} />,
});